import type { Deal } from '../types/Deal';

export default (deal: Deal): string | null => {
  if (deal?.offer?.was_price) {
    const saving = parseFloat((deal.offer.was_price - parseFloat(deal.offer.price)).toFixed(2));
    return ((saving / deal.offer.was_price) * 100).toFixed(0);
  }
  return null;
};
